// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"79c4728b","453":"825386d9","898":"11bb965b"}[chunkId] + ".chunk.js";
};